<template>
	<v-container grid-list-xl fill-height class="container--box white--text">
		<v-layout row wrap fill-height>
			<v-flex xs12 md12>
				<h2 class="py-5">{{ $t("title.your_wallet") }}</h2>
			</v-flex>
			<v-flex xs12 md4>
				<v-card>
					<v-card-title class="py-10">
						<v-layout row wrap class="text-center">
							<v-flex xs12>
								<v-avatar size="120" color="primary">
									<v-icon size="80" dark>mdi-wallet</v-icon>
								</v-avatar>
							</v-flex>
							<v-flex xs12>
								<h3 class="text-center">
									{{ $t("title.current_balance") }}
								</h3>
							</v-flex>
							<v-flex xs12>
								<h1 class="font-weight-bold">
									{{ customer_balance }}
									<small>pts</small>
								</h1>
							</v-flex>
						</v-layout>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-subheader class="py-0">
									<strong>{{ $t("label.topup") }}</strong>
								</v-subheader>
								{{ $t("label.click_on_coupon_below_to_topup") }}
							</v-flex>
							<v-flex
								xs12
								v-for="(coupon, index) in coupons"
								:key="index"
							>
								<Link
									as="v-list-item"
									:href="
										$route('wallet.topups.create', {
											coupon: coupon.uuid,
										})
									"
								>
									<v-list-item-avatar>
										<v-avatar color="primary">
											<v-icon dark>
												mdi-wallet-plus-outline
											</v-icon>
										</v-avatar>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title>
											{{ coupon.name }}
										</v-list-item-title>
										<v-list-item-subtitle>
											{{ coupon.description }}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action-text>
										<v-btn text>
											<strong>{{ coupon.price }}</strong>
										</v-btn>
										<br />
										<v-btn text>
											{{ coupon.credit }}
										</v-btn>
									</v-list-item-action-text>
								</Link>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs12 md8>
				<v-card class="mx-auto">
					<v-card-title>
						{{ $t("label.transactions") }}
					</v-card-title>
					<v-card-text>
						<v-list subheader two-line>
							<template
								v-for="(transaction, index) in transactions"
							>
								<v-list-item :key="`list-${index}`">
									<v-list-item-content>
										<v-list-item-title
											v-text="transaction.title"
										></v-list-item-title>

										<v-list-item-subtitle>
											{{ transaction.description }}
											<p>
												<small>
													{{ transaction.created_at }}
												</small>
											</p>
										</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<v-btn
											:color="
												transaction.type == 'deposit'
													? 'success'
													: 'error'
											"
											text
											small
										>
											{{ transaction.amount }}
										</v-btn>
									</v-list-item-action>
								</v-list-item>
								<v-divider
									:key="`divider-${index}`"
									v-if="index + 1 < transactions.length"
								></v-divider>
							</template>
						</v-list>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import { Link } from "@inertiajs/inertia-vue";
	export default {
		components: {
			Link,
		},

		props: ["customer_balance", "topups", "coupons", "transactions"],

		methods: {
			topup(coupon) {
				//
			},
		},
	};
</script>